import React, { useContext } from 'react'
import GlobalPopUp from '../../../utility/globalPopUp'
import { Grid, Typography } from '@mui/material';
import ConfirmationPopover from '../../../utility/confirmationPopover';
import { chatbotIntegrationAssignmentDataNew, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import GlobalButton from '../../../utility/globalButton/button';
import IconsColor from '../../../utility/iconsColor';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import FacebookInformationCard from '../../../utility/facebookInformationCard';
import { useSearchParams } from 'react-router-dom';
import integrationStyles from '../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import popupStyles from "../../../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import { primaryColor } from '../../../../utils/colors';

interface addChatbotIntegrationDetailsInterface {
    chatbot_id: string,
    integrated_channel_id: string

}

interface ShowAvailablePhoneNumbersProps {
    flagShowAvailableNumbers: boolean,
    setFlagShowAvailableNumbers: React.Dispatch<React.SetStateAction<boolean>>;
    smallScreen: boolean,
    showConfirmationPopover: boolean,
    confirmationPopoverAnchorEl: null | HTMLButtonElement,
    handleCloseConfirmationPopover: () => void,
    addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface,
    AddChatbotIntegration: (addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface) => void;
    availablePhoneNumberData: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[],
    handleRemoveChatbotIntegration: (integrated_channel_id: string, display_phone_number: string) => void,
    displayPhoneNumber: string,
    launchWhatsAppSignup: () => void
    saveChatbotIntegrationData: (display_page_name: string, integrated_channel_id: string, event?: React.MouseEvent<HTMLButtonElement>) => void
}

function ShowAvailablePages(props: ShowAvailablePhoneNumbersProps) {
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const [searchParams] = useSearchParams()
    const { flagShowAvailableNumbers, setFlagShowAvailableNumbers, smallScreen, showConfirmationPopover, confirmationPopoverAnchorEl, handleCloseConfirmationPopover, addChatbotIntegrationDetails, AddChatbotIntegration, availablePhoneNumberData, handleRemoveChatbotIntegration, launchWhatsAppSignup, displayPhoneNumber, saveChatbotIntegrationData } = props

    return (
        <div>
            <GlobalPopUp
                open={flagShowAvailableNumbers}
                handleClose={() => { setFlagShowAvailableNumbers(false) }}
                flagShowCloseIcon
                paperMinWidth={smallScreen ? '85%' : '90vw'}
                titlePadding='0px'
                height='90vh'
                overflow='hidden'
            >
                <Grid container direction={"column"} flexWrap={"nowrap"} className={integrationStyles.integrationPopupContainer} mt={{ xs: 1, lg: 0 }}>
                    <Grid item className={`${globalStyles.textCenter} ${integrationStyles.integrationPopupTitle}`}>
                        <Typography className={popupStyles.popupTitleTypography} marginBlock={'5px'}>
                            Add Facebook Pages
                        </Typography>
                    </Grid>

                    <Grid item className={integrationStyles.intergationPopupBody}>
                        <Grid container direction={"column"} flexWrap={"nowrap"} className={integrationStyles.metaIntegrationPopupContainer}>
                            <Grid item>
                                <Grid container gap="15px">
                                    <ConfirmationPopover
                                        open={showConfirmationPopover}
                                        anchorEl={confirmationPopoverAnchorEl}
                                        handleClose={handleCloseConfirmationPopover}
                                        onConfirmation={() => { AddChatbotIntegration(addChatbotIntegrationDetails) }}
                                        descriptionText={<p>Are you sure you want to deploy <span style={{ fontWeight: "600" }}>{chatBotDetails?.chatbot_name}</span> on <span style={{ fontWeight: "600" }}>{displayPhoneNumber}</span> ?</p>}
                                    />
                                    {availablePhoneNumberData.filter((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => data.channel_name === "Facebook").length > 0 && availablePhoneNumberData.filter((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => data.channel_name === "Facebook").map((integrationData, index) => (
                                        <Grid container key={index} direction={"column"} gap="15px" sx={{ width: "auto" }}>
                                            <Grid item>
                                                <Grid container gap="15px">
                                                    <FacebookInformationCard
                                                        integrationType='Facebook'
                                                        key={index}
                                                        flagShowLinkedChatbot
                                                        flagDelete={false}
                                                        title={`WhatsApp Account ${index + 1}`}
                                                        currentlySelected={"chatbot_integration_assignment_data" in integrationData && integrationData?.chatbot_integration_assignment_data.some((chatbot: chatbotIntegrationAssignmentDataNew) => chatbot?.chatbot_id?.toString() == searchParams.get('chatbot_id')) || false}
                                                        showRemoveChatbotIntegration={false}
                                                        disabled={("chatbot_integration_assignment_data" in integrationData && integrationData?.chatbot_integration_assignment_data && integrationData?.chatbot_integration_assignment_data.length > 0) ? true : false}
                                                        removeChatbotIntegration={() => { handleRemoveChatbotIntegration(String(integrationData.integrated_channel_id), "page_name" in integrationData ? integrationData?.page_name : "") }}
                                                        addChatbotIntegration={("chatbot_integration_assignment_data" in integrationData && integrationData?.chatbot_integration_assignment_data.length == 0) ? (page_id: any, event: any) => {
                                                            if (event) {
                                                                saveChatbotIntegrationData("page_name" in integrationData ? integrationData.page_name : "", String(integrationData.integrated_channel_id), event)
                                                            } else {
                                                                saveChatbotIntegrationData("page_name" in integrationData ? integrationData.page_name : "", String(integrationData.integrated_channel_id) || "")
                                                            }
                                                        } : undefined}
                                                        details={{
                                                            page_id: "page_id" in integrationData ? integrationData.page_id : "",
                                                            integrated_channel_id: String(integrationData.integrated_channel_id),
                                                            page_name: "page_name" in integrationData ? integrationData.page_name : "",
                                                            page_category: "page_category" in integrationData ? integrationData.page_category : "",
                                                            linked_chatbots: "chatbot_integration_assignment_data" in integrationData ? integrationData?.chatbot_integration_assignment_data : undefined,
                                                        }}
                                                        flagIntegration={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Facebook Account"
                                    onClick={launchWhatsAppSignup}
                                    className='borderedButtonStyle'
                                    sx={{ padding: '8px 16px !important' }}
                                    startIcon={<IconsColor fillColor={primaryColor} iconName="plus" width="16px" height="16px" />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </GlobalPopUp>
        </div>
    )
}

export default ShowAvailablePages